import Rajendra_Yadav_Resume from "../assets/pdf/Rajendra_Yadav_Resume.pdf";
import rajendra from "../assets/png/rajendra.png";
export const headerData = {
  name: "Rajendra Yadav",
  title: "Web Developer",
  desciption:
    "“Passion is one great force that unleashes creativity, because if you're passionate about something, then you're more willing to take risks.”",
  image: rajendra,
  resumePdf: Rajendra_Yadav_Resume,
};
